import React, { useState } from 'react';
import {
  Button,
  Typography,
  LinearProgress,
  Box,
} from '@mui/material';
import axios from 'axios';

const ProductInsertSection = ({ showSnackbar }) => {
  const [loading, setLoading] = useState(false);

  const insertProduct = async () => {
    setLoading(true);
    try {
      await axios.post('/api/v1/google-merchant/insert-merchent-product');
      showSnackbar('✅ Product inserted successfully');
    } catch {
      showSnackbar('❌ Failed to insert product', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>Insert Product to Google Merchant</Typography>

      {loading && <LinearProgress sx={{ mb: 2 }} />}

      <Button
        variant="contained"
        color="primary"
        onClick={insertProduct}
        disabled={loading}
        sx={{ mb: 2 }}
      >
        {loading ? 'Inserting...' : 'Insert Product'}
      </Button>
    </Box>
  );
};

export default ProductInsertSection;
